'use client'

import { Lightbulb, Eye, Star } from 'lucide-react'
import TOC, { type Chapter } from './TOC'

interface SidebarV2Props {
  chapters?: Chapter[]
  expandedChapterIds?: Set<string>
  activeChapter?: string
  onToggleSelectAll?: () => void
  onToggleChapterExpansion?: (id: string) => void
  onScrollToChapter?: (id: string) => void
}

export default function SidebarV2({
  chapters = [],
  expandedChapterIds = new Set(),
  activeChapter = '',
  onToggleSelectAll = () => { },
  onToggleChapterExpansion = () => { },
  onScrollToChapter = () => { },
}: SidebarV2Props) {
  return (
    <aside className="space-y-4">
      {/* TOC - Table of Contents */}
      {chapters.length > 0 && (
        <TOC
          chapters={chapters}
          visibleChapterIds={expandedChapterIds}
          activeChapter={activeChapter}
          onToggleSelectAll={onToggleSelectAll}
          onToggleChapterVisibility={onToggleChapterExpansion}
          onScrollToChapter={onScrollToChapter}
        />
      )}

      {/* Guide Card */}
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm p-5">
        <h3 className="sidebar-title mb-4">
          <Lightbulb size={20} className="text-primary-blue-500" />
          Hướng dẫn tra cứu
        </h3>
        <ul className="guide-list">
          <li className="guide-item">
            Click vào mã HS để xem chi tiết thông tin thuế và quy định
          </li>
          <li className="guide-item">
            Cấu trúc: Chương → Nhóm (4 số) → Mã chi tiết (8-10 số)
          </li>
          <li className="guide-item">
            Click nút{' '}
            <Star size={14} style={{ display: 'inline', color: 'var(--primary-blue-500)' }} /> để
            lưu mã vào danh sách yêu thích
          </li>
        </ul>
      </div>

    </aside>
  )
}
